export const UI_QUICK_ACTIONS = "quick_actions";
export const UI_GUIDED_FLOW = "guided_flow";
export const UI_SPECIALTY_PICKER = "specialty_picker";
export const UI_DOCTOR_CARDS = "doctor_cards";
export const UI_CALENDAR_PICKER = "calendar_picker";
export const UI_TIME_SLOT_PICKER = "time_slot_picker";
export const UI_TIME_RANGE_PICKER = "time_range_picker";
export const UI_TEXT_INPUT = "text_input";
export const UI_WEEKDAY_PICKER = "weekday_picker";
export const UI_AVAILABILITY_CARD = "availability_card";
export const UI_AVAILABILITY_SLOTS = "availability_slots";
export const UI_CONFIRMATION_CARD = "confirmation_card";
export const UI_APPOINTMENT_CARD = "appointment_card";
export const UI_EVENT_CARD = "event_card";
export const UI_MEDICAL_RECORD_CARD = "medical_record_card";
export const UI_MEDICATION_CARD = "medication_card";
export const UI_LOCATION_CARD = "location_card";
export const UI_GPT_CHAT_INPUT = "gpt_chat_input";
export const UI_GPT_RESPONSE_CARD = "gpt_response_card";
